import { useQuery } from "@tanstack/react-query";

import { getDataFromResponse } from "~/api/axiosUtils.ts";
import { getAllPermissions, getAuthenticatedUser } from "~/modules/auth/api/auth/authApiDispatchers.ts";

export const GET_AUTHENTICATED_USER_QUERY_KEY = ["authenticatedUser"];

export const useAuthenticatedUserQuery = (enabled: boolean) => useQuery({
	queryKey: GET_AUTHENTICATED_USER_QUERY_KEY,
	queryFn: () => getAuthenticatedUser().then(getDataFromResponse),
	enabled,
});

export const ALL_PERMISSIONS_QUERY_KEY = ["permissions", "all"];

export const useAllPermissions = () => useQuery({
	queryKey: ALL_PERMISSIONS_QUERY_KEY,
	queryFn: () => getAllPermissions().then(getDataFromResponse),
});